import type { Kiosk } from '@gozoki/api-types'
import { type UseQueryResult, useQuery } from '@tanstack/react-query'
import { fetchKiosk, fetchKiosks } from '../queries/kiosks.queries'

export const useKiosks = (): UseQueryResult<Kiosk[], unknown> =>
  useQuery({
    queryKey: ['kiosks'],
    queryFn: () => fetchKiosks(),
  })

export const useKiosk = (id: number): UseQueryResult<Kiosk | null, unknown> =>
  useQuery({
    queryKey: ['kiosk', id],
    queryFn: () => {
      if (Number.isNaN(id)) {
        return null
      }
      return fetchKiosk(id)
    },
  })
